import { useState } from "react"

export default function useViewportWidth() {
    const [viewportWidth, setViewportWidth] = useState(document.documentElement.clientWidth)
    return viewportWidth
}